import { z } from "zod/v4";
import { snapshotRowSchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

export interface EntitySnapshotsParams {
	entityType?: string;
	entityId?: string;
	since?: string;
	limit?: number;
}

export const entitySnapshots = {
	list: (params: EntitySnapshotsParams = {}) => {
		const query = new URLSearchParams();
		if (params.entityType) query.set("entityType", params.entityType);
		if (params.entityId) query.set("entityId", params.entityId);
		if (params.since) query.set("since", params.since);
		if (params.limit) query.set("limit", String(params.limit));
		const qs = query.toString();
		return fetchApi(`/snapshots${qs ? `?${qs}` : ""}`, z.array(snapshotRowSchema));
	},
};
